import IAddress from "./protocols/IAddress";
import IRegion from "./protocols/IRegion";

export default class Address implements IAddress {
  id: number = 0;
  city: string = "";
  countryId: string = "";
  customerId: number = 0;
  default_billing: boolean = false;
  default_shipping: boolean = false;
  firstname: string = "";
  lastname: string = "";
  postcode: string = "";
  region: IRegion = {
    region: "",
    regionCode: "",
    regionId: 0,
  };
  street: string[] = [""];
  telephone: string = "";
}
